module.exports = __webpack_public_path__ + "img/05.4d333142.jpeg";